import { useEffect } from 'react'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import { fetchFaq } from './actions'
import { selectFaq, selectFaqFetching } from './selectors'
import Faq from 'components/Faq'
import { updateTitle } from '../Breadcrumbs/actions'
import { selectCurrentPhoneId } from '../App/selectors'
import { addRecent } from '../RecentTopics/actions'
import { getCustomer } from 'helpers'

// If link doesn't starts with "http" or "//" replacing to links name.
// TODO: move to helpers and refactor
const takeOutInternalLinks = (str) => {
  const regex = RegExp(/<a\b[^>]*>(.*?)<\/a>/i, 'g')
  let links
  while ((links = regex.exec(str)) !== null) {
    if (!(links[0].includes('http') || links[0].includes('//'))) {
      str = str.replace(links[0], links[1])
    }
  }
  return str
}

const FaqContainer = ({
  params: { id },
  faq,
  isFetching,
  device,
  createEvent,
  addRecent,
  fetchFaq,
  location
}) => {
  useEffect(() => {
    fetchFaq(id)
  }, [id])

  useEffect(() => {
    if (faq.PK) {
      updateTitle(faq.name)
      createEvent({
        category: 'faqs',
        data: { action: 'ToggleSingleFAQ', target: faq.PK, faq_name: faq.name }
      })
      addRecent({
        contentType: 'faq',
        contentId: faq.PK,
        deviceId: faq.phonefk,
        contentTitle: faq.name,
        customer: getCustomer()
      })
    }
  }, [faq])

  return (
    <Faq
      faq={faq}
      isFetching={isFetching}
      takeOutInternalLinks={takeOutInternalLinks}
      id={id}
      device={device || faq.phonefk}
    />
  )
}

const mapStateToProps = (state) => ({
  faq: selectFaq(state),
  isFetching: selectFaqFetching(state),
  device: selectCurrentPhoneId(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchFaq: (faqId) => dispatch(fetchFaq.request(faqId)),
  updateTitle: (title) => dispatch(updateTitle(title)),
  addRecent: (topic) => dispatch(addRecent(topic))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(FaqContainer))
